import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { DecisionTreeButton } from '../../../../../common/buttonsComponents';
import { QuickActionButton } from '../../DTQuestionOrInstruction.styles';
import { getDecisionNodeAtPath, getChildrenOfCurrentDecisionNode } from '../../../../../../extractFromState';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import { trackQuickActionClick } from '../../../../../../analytics/buttonEventAnalytics';
import { trackDecisionNodeQuestionAnswered } from '../../../../../../analytics/searchEventAnalytics';
import { runQuickAction, showQuickActionButton } from '../../../../../../actions/tools/OrdersSearchActions';
import { formatTextForDecisionTreeButton } from '../../../../../../util';
import { setLoading } from '../../../../../../actions';

const ButtonList = ({ isButtonDisabled, selectionAction, hiddenButtons = [] }) => {
  const decisionNodeChildren = useSelector(getChildrenOfCurrentDecisionNode);
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const dispatch = useDispatch();

  const isQuickActionButtonActive = () => {
    if (decisionNode?.quickAction) {
      // TODO: This should be a selector, not an action
      return dispatch(showQuickActionButton(decisionNode.quickAction));
    }

    return false;
  };

  const handleQuickAction = async () => {
    trackQuickActionClick();

    if (decisionNode?.quickAction) {
      dispatch(setLoading(true, 'DecisionTreeContainer'));
      await dispatch(runQuickAction(decisionNode.quickAction));
      dispatch(setLoading(false, 'DecisionTreeContainer'));
    }
  };

  const handleSelection = async (choice) => {
    trackDecisionNodeQuestionAnswered(choice);

    if (selectionAction) {
      await selectionAction(choice);
    }

    dispatch(addEdgeToDecisionTreePath(choice));
  };

  // make buttons from decision tree edges
  const buttonList = [];
  const buttonTextOverrides = decisionNode?.buttonTextOverrides ?? {};
  for (let choice in decisionNodeChildren) {
    const buttontext = (buttonTextOverrides && buttonTextOverrides[choice]) || formatTextForDecisionTreeButton(choice);

    if (!hiddenButtons.includes(choice)) {
      buttonList.push(
        <DecisionTreeButton disabled={isButtonDisabled} key={buttontext} onClick={() => handleSelection(choice)}>
          {buttontext}
        </DecisionTreeButton>
      );
    }
  }

  if (isQuickActionButtonActive()) {
    buttonList.push(
      <QuickActionButton key="quick_action_button" onClick={() => handleQuickAction()}>
        Quick Cancel
      </QuickActionButton>
    );
  }

  return buttonList;
};

ButtonList.propTypes = {
  isButtonDisabled: PropTypes.bool.isRequired,
  selectionAction: PropTypes.func,
  hiddenButtons: PropTypes.array,
};

export default ButtonList;
